module.exports = __webpack_public_path__ + "media/images/laboratory-0d8500eed3349c0b57589e531c466ba1.png";